import { Table, Typography } from "antd";

const { Text } = Typography;

const dataSource = [
  {
    key: "1",
    serial: 1,
    invoiceNo: "INV123456",
    amount: 200000,
    date: "23-10-2023",
    dueDate: "26-10-2023",
  },
  {
    key: "2",
    serial: 2,
    invoiceNo: "INV456123",
    amount: 500000,
    date: "01-11-2023",
    dueDate: "04-11-2023",
  },
];

const columns = [
  {
    title: "Serial No.",
    dataIndex: "serial",
    key: "serial",
  },
  {
    title: "Invoice No.",
    dataIndex: "invoiceNo",
    key: "invoiceNo",
  },
  {
    title: "Invoice Amount",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "Invoice Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Invoice Due Date",
    dataIndex: "dueDate",
    key: "dueDate",
  },
];

const InvoiceFormatTable = () => {
  return (
    <>
      <Text style={{ display: "block", color: "#40566D", marginBottom: 12, marginTop: 40, fontSize: 14 }}>
        Ensure your summary sheet follows this format:
      </Text>
      <div className="invoice-format-table">
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          bordered
          scroll={{ x: "max-content" }}
        />
      </div>
    </>
  );
};

export default InvoiceFormatTable;
